import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import MenuItem from "@mui/material/MenuItem";
import Menu from "@mui/material/Menu";
import classnames from "classnames";
import { Icon } from "../../Icon/index.js";
import { Box } from "../../Box/index.js";
import { Typography } from "../../Typography/index.js";
import { Badge } from "../../Badge/index.js";
import { EllipsisText } from "../../EllipsisText/index.js";
import DropdownInput_styles from "./DropdownInput.styles.js";
const DropdownInput = (t0)=>{
    const $ = c(35);
    const { value, items, testId, onChange, size: t1 } = t0;
    const size = void 0 === t1 ? "small" : t1;
    const { classes } = DropdownInput_styles();
    let t2;
    if ($[0] !== items || $[1] !== value) {
        let t3;
        if ($[3] !== value) {
            t3 = (option)=>option.value === value;
            $[3] = value;
            $[4] = t3;
        } else t3 = $[4];
        t2 = items.find(t3);
        $[0] = items;
        $[1] = value;
        $[2] = t2;
    } else t2 = $[2];
    const selectedOption = t2;
    let t3;
    if ($[5] !== items) {
        t3 = items.some(_temp);
        $[5] = items;
        $[6] = t3;
    } else t3 = $[6];
    const hasActiveOptions = t3;
    const [anchorEl, setAnchorEl] = useState(null);
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = (event)=>{
            setAnchorEl(event.currentTarget);
        };
        $[7] = t4;
    } else t4 = $[7];
    const handleClick = t4;
    let t5;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
        t5 = ()=>{
            setAnchorEl(null);
        };
        $[8] = t5;
    } else t5 = $[8];
    const handleClose = t5;
    let t6;
    if ($[9] !== classes.dropdown) {
        t6 = classnames(classes.dropdown, "aqa_dropdown_input");
        $[9] = classes.dropdown;
        $[10] = t6;
    } else t6 = $[10];
    const t7 = "small" === size ? "h6" : "h5";
    const t8 = selectedOption ? selectedOption.label : "-";
    let t9;
    if ($[11] !== t7 || $[12] !== t8) {
        t9 = /*#__PURE__*/ jsx(Typography, {
            variant: t7,
            component: "div",
            noWrap: true,
            children: t8
        });
        $[11] = t7;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    let t10;
    if ($[14] !== items.length) {
        t10 = items.length > 1 && /*#__PURE__*/ jsx(Icon, {
            name: "dropdown",
            color: "original.brand.primary",
            size: "24"
        });
        $[14] = items.length;
        $[15] = t10;
    } else t10 = $[15];
    let t11;
    if ($[16] !== hasActiveOptions) {
        t11 = hasActiveOptions && /*#__PURE__*/ jsx(Box, {
            display: "flex",
            alignSelf: "flex-start",
            width: 6,
            height: "100%",
            ml: "-8",
            position: "relative",
            children: /*#__PURE__*/ jsx(Badge, {
                visible: hasActiveOptions
            })
        });
        $[16] = hasActiveOptions;
        $[17] = t11;
    } else t11 = $[17];
    let t12;
    if ($[18] !== t10 || $[19] !== t11 || $[20] !== t6 || $[21] !== t9 || $[22] !== testId) {
        t12 = /*#__PURE__*/ jsxs(Box, {
            className: t6,
            display: "flex",
            alignItems: "center",
            onClick: handleClick,
            gap: "8",
            testId: testId,
            children: [
                t9,
                t10,
                t11
            ]
        });
        $[18] = t10;
        $[19] = t11;
        $[20] = t6;
        $[21] = t9;
        $[22] = testId;
        $[23] = t12;
    } else t12 = $[23];
    let t13;
    if ($[24] !== anchorEl || $[25] !== classes.menuItem || $[26] !== classes.menuList || $[27] !== classes.menuPaper || $[28] !== items || $[29] !== onChange || $[30] !== value) {
        t13 = items.length > 1 && /*#__PURE__*/ jsx(Menu, {
            elevation: 0,
            anchorOrigin: {
                vertical: "bottom",
                horizontal: "left"
            },
            transformOrigin: {
                vertical: "top",
                horizontal: "left"
            },
            anchorEl: anchorEl,
            keepMounted: true,
            open: Boolean(anchorEl),
            onClose: handleClose,
            classes: {
                list: classes.menuList,
                paper: classes.menuPaper
            },
            children: items.map((item_0)=>/*#__PURE__*/ jsxs(MenuItem, {
                    value: item_0.value,
                    onClick: ()=>{
                        onChange(item_0.value);
                        handleClose();
                    },
                    className: classes.menuItem,
                    children: [
                        /*#__PURE__*/ jsx(Typography, {
                            color: item_0.value === value ? "original.brand.primary" : "text.light.primary",
                            variant: "body3",
                            children: /*#__PURE__*/ jsx(EllipsisText, {
                                rows: 1,
                                children: item_0.label
                            })
                        }),
                        item_0.active && /*#__PURE__*/ jsx(Box, {
                            display: "flex",
                            height: 18,
                            width: 12,
                            justifyContent: "end",
                            children: /*#__PURE__*/ jsx(Box, {
                                width: 6,
                                height: 6,
                                bgcolor: "accent.text.error",
                                radius: "round"
                            })
                        })
                    ]
                }, item_0.value))
        });
        $[24] = anchorEl;
        $[25] = classes.menuItem;
        $[26] = classes.menuList;
        $[27] = classes.menuPaper;
        $[28] = items;
        $[29] = onChange;
        $[30] = value;
        $[31] = t13;
    } else t13 = $[31];
    let t14;
    if ($[32] !== t12 || $[33] !== t13) {
        t14 = /*#__PURE__*/ jsxs("div", {
            children: [
                t12,
                t13
            ]
        });
        $[32] = t12;
        $[33] = t13;
        $[34] = t14;
    } else t14 = $[34];
    return t14;
};
function _temp(item) {
    return !!item.active;
}
export { DropdownInput };
